export const nonFieldErrorsKey = 'non_field_errors';
export const paymentSystemTypeErrorKey = 'payment_system_type';
export const paymentNeedBillingInfoErrorKey = 'billing_info_not_found';
